<template>
  <v-img :src="logo" :height="height ? height : '100%'" contain />
</template>
<script>
export default {
  name: "Logo",
  props: ["height"],
  computed: {
    logo() {
      return require(`@/assets/MerloLogo${
        this.$vuetify.theme.dark ? "Dark" : "Light"
      }.png`);
    }
  }
};
</script>

<style lang="css" scoped></style>
